<template>
  <div class="lang-switch">
    <Button
      variant="ghost"
      view="light"
      size="sm"
      class="lang-switch__trigger">
      <Icon
        name="global"
        size="s"/>
      <span>
        {{ currentLocale.title }}
      </span>
    </Button>
    <ul
      class="lang-switch__list"
      :class="{ 'lang-switch__list--show': showLocales }">
      <li
        v-for="locale in availableLocales"
        :key="locale.code"
        class="lang-switch__item">
        <Button
          variant="ghost"
          @click="setLocale(locale.code)"
          class="lang-switch__item-button">
          <img
            :src="locale.img"
            :alt="locale.code">
          <span>
            {{ locale.title }}
          </span>
        </Button>
      </li>
    </ul>
  </div>
</template>

<script>
import Icon from '@rr-component-library/icon/src/main';
import Button from '@rr-component-library/button/src/main';
import existingLocales from './locales';

const localesCodes = existingLocales.map(locale => locale.code);

export default {
  name: 'LangSwitch',
  components: {
    Icon,
    Button,
  },
  props: {
    locales: {
      type: Array,
      default: () => [],
      validator(val) {
        return val.every(locale => localesCodes.includes(locale));
      },
    },
    initialLocaleCode: {
      type: String,
    }
  },
  data() {
    return {
      langs: existingLocales,
      showLocales: false,
      currentLocaleCode: this.initialLocaleCode,
    };
  },
  methods: {
    setLocale(localeCode) {
      this.currentLocaleCode = localeCode;
      this.$emit('change', this.currentLocaleCode);
    },
  },
  computed: {
    availableLocales() {
      return existingLocales.filter(locale => {
        return this.locales.includes(locale.code) && locale.code !== this.currentLocaleCode;
      });
    },
    currentLocale() {
      return existingLocales.find(locale => locale.code === this.currentLocaleCode);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./LangSwitch";
</style>
